import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Panel, PanelGroup, Placeholder } from 'rsuite';
import { AssociationWebsite } from '../../apis/urls';

const AssociationAccordian = () => {

	useEffect(()=> {
		associationWebSiteList();
	}, [])

	const [result, setResult] = useState([])

	const associationWebSiteList  = () => { 
	
		const instance = axios.create({
			baseURL: AssociationWebsite,
			timeout: 1000000,
		});
		instance.get('').then((response) =>{
			setResult(response?.data?.data)
		}).catch((error) =>{     
			console.log('error',error.message)  
		});
	}

  return (
    <div>
		<PanelGroup accordion>
			{result?.map((item, index) => (
				<Panel header={item.name} eventKey={index} id="panel1" key={index}>
					{item?.association?.map((items, indexes) => (
						<div style={{fontFamily:'Poppins', marginBottom:"20px"}}>
							<p class="navyblue"  style={{color:'#0000ff', fontFamily:'Poppins', marginBottom:"0px"}}><strong>{items.name}</strong></p>
							<span style={{color:'#ff0000', fontFamily:'Poppins'}}><strong>{items?.pri_firstname} {items?.pri_lastname}</strong></span>
							<br />
							EMAIL: {items.pri_email}
							<br />
							PHONE: {items.pri_phone}
						</div>
					))}
				</Panel>
			))}
		</PanelGroup>
    </div>
  )
}

export default AssociationAccordian
